import { IHomesite } from "../../api/homesites/homesites.types";

export interface State {
  selectedValue: string;
  lastSelectedDivision: string;
  filteredData: IHomesite[];
}

export const initialState: State = {
  selectedValue: "",
  lastSelectedDivision: "",
  filteredData: [],
};

export interface ConciergeContextProps {
  value: string | undefined;
  label: string | undefined;
  setMyConcierge: (value: string, label: string) => void;
}

export type Action =
  | { type: "SET_SELECTED_VALUE"; payload: string }
  | { type: "SET_LAST_SELECTED_DIVISION"; payload: string }
  | { type: "SET_FILTERED_DATA"; payload: IHomesite[] };